import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { addressLocation, emailAddress, confirm, thanks, phoneNumber } from './common-steps'
import { currentProviderInternet } from './internet-steps'
import { currentProviderMobile } from './mobile-steps'

// export const startLead: ScenarioStep = {
//   id: Steps.START_LEAD,
//   group: QuestionGroup.LEAD,
//   question: 'start-lead_question',
//   tip: 'start-lead_tip',
//   type: QuestionType.LEAD,
//   next: Steps.ADDRESS_LOCATION,
//   answers: [
//     {
//       id: 'start',
//       text: 'common_next',
//     },
//   ],
// }

export const thanksLead: ScenarioStep = {
  ...thanks,
  question: 'thanks-lead_question',
  tip: 'thanks-lead_tip',
}

export const addressLocationLead: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.LEAD,
  tip: 'address-location_tip',
  answerPlaceholder: 'address-location-lead_answerPlaceholder',
  next: Steps.PROVIDER_AVAILABILITY,
}

export const emailAddressLead: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.ADDRESS_LOCATION,
  metadata: { grandImage: Images.LEAD_1 },
}

export const emailAddressLeadC: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  metadata: { grandImage: Images.LEAD_1 },
}

export const emailAddressLeadCC: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.CURRENT_PROVIDER_INTERNET_LEAD,
  metadata: { grandImage: Images.LEAD_1 },
}

export const confirmLead: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_LEAD,
  group: QuestionGroup.LEAD,
  answerPlaceholder: 'confirm-lead_answerPlaceholder',
  next: Steps.THANKS,
}

export const providerAvailability: ScenarioStep = {
  id: Steps.PROVIDER_AVAILABILITY,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.PROVIDER_AVAILABILITY,
  answers: [
    {
      id: 'continue-with-provider',
      text: 'common_continue',
      next: Steps.FIRST_NAME,
    },
  ],
}

export const newClientVerification: ScenarioStep = {
  id: Steps.NEW_CLIENT_VERIFICATION,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.NEW_CLIENT_VERIFICATION,
  answers: [
    {
      id: 'continue-with-provider',
      text: 'common_continue',
    },
  ],
  next: Steps.ADDRESS_LOCATION,
}

export const phoneNumberLead: ScenarioStep = {
  ...phoneNumber,
  next: Steps.CONFIRM_LEAD,
}

export const phoneNumberLeadB: ScenarioStep = {
  ...phoneNumber,
  next: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
}

export const currentProviderMobileLead: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  next: Steps.CONFIRM_LEAD,
}

export const currentProviderMobileLeadC: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  next: Steps.NEW_CLIENT_VERIFICATION,
}

export const currentProviderInternetLead: ScenarioStep = {
  ...currentProviderInternet,
  id: Steps.CURRENT_PROVIDER_INTERNET_LEAD,
  next: Steps.NEW_CLIENT_VERIFICATION,
}
